import axios from 'axios'

const token = import.meta.env.VITE_APP_MECEF_API_TOKEN

const config = {
    baseURL: 'https://developper.impots.bj/sygmef-emcf/api/',
};

const sygmefAxios = axios.create(config)



export default sygmefAxios